import { render, staticRenderFns } from "./ExpressOrderTable.vue?vue&type=template&id=754b32fe&scoped=true"
import script from "./ExpressOrderTable.vue?vue&type=script&lang=js"
export * from "./ExpressOrderTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754b32fe",
  null
  
)

export default component.exports